var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixRestaurantsV1FulfillmentMethod from '@wix/ambassador-restaurants-v1-fulfillment-method/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
let __verbose = false;
function __log(...args) {
    __verbose && console.log(...args);
}
function __inspect(obj) {
    return obj;
}
export const __debug = {
    verboseLogging: {
        on: () => (__verbose = true),
        off: () => (__verbose = false),
    },
};
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var FulfillmentMethodType;
(function (FulfillmentMethodType) {
    /** Missing type due to an error. */
    FulfillmentMethodType["UNKNOWN_FULFILLMENT_TYPE"] = "UNKNOWN_FULFILLMENT_TYPE";
    /** Pickup fulfillment method - refers to the customer picking up the order from the restaurant. */
    FulfillmentMethodType["PICKUP"] = "PICKUP";
    /** Delivery fulfillment method - refers to the restaurant or someone on behalf of the restaurant delivering the order to the customer. */
    FulfillmentMethodType["DELIVERY"] = "DELIVERY";
})(FulfillmentMethodType || (FulfillmentMethodType = {}));
export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
export var Type;
(function (Type) {
    /** Unknown delivery area type. */
    Type["UNKNOWN_DELIVERY_AREA"] = "UNKNOWN_DELIVERY_AREA";
    /**
     * Delivery area that is defined by a radius around an address.
     * The address of the restaurant will be used.
     */
    Type["RADIUS"] = "RADIUS";
    /** Delivery area that is defined by a list of postal codes. */
    Type["POSTAL_CODE"] = "POSTAL_CODE";
    /** Delivery area that is defined by a custom polygon. */
    Type["CUSTOM"] = "CUSTOM";
})(Type || (Type = {}));
export var Unit;
(function (Unit) {
    /** Unknown unit. */
    Unit["UNKNOWN_UNIT"] = "UNKNOWN_UNIT";
    /** Miles. */
    Unit["MILES"] = "MILES";
    /** Kilometers. */
    Unit["KILOMETERS"] = "KILOMETERS";
})(Unit || (Unit = {}));
export var EntitiesDayOfWeek;
(function (EntitiesDayOfWeek) {
    /** Monday. */
    EntitiesDayOfWeek["MON"] = "MON";
    /** Tuesday. */
    EntitiesDayOfWeek["TUE"] = "TUE";
    /** Wednesday. */
    EntitiesDayOfWeek["WED"] = "WED";
    /** Thursday. */
    EntitiesDayOfWeek["THU"] = "THU";
    /** Friday. */
    EntitiesDayOfWeek["FRI"] = "FRI";
    /** Saturday. */
    EntitiesDayOfWeek["SAT"] = "SAT";
    /** Sunday. */
    EntitiesDayOfWeek["SUN"] = "SUN";
})(EntitiesDayOfWeek || (EntitiesDayOfWeek = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
/** Enumerates the days of the week. */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
const _createFulfillmentMethodRequest = {
    fulfillmentMethod: '_fulfillmentMethod',
};
const _createFulfillmentMethodResponse = {
    fulfillmentMethod: '_fulfillmentMethod',
};
const _deleteFulfillmentMethodRequest = {};
const _deleteFulfillmentMethodResponse = {};
const _deliveryArea = { radiusOptions: '_radius' };
const _deliveryInfo = { deliveryArea: '_deliveryArea' };
const _fulfillmentMethod = {
    pickupOptions: '_pickupInfo',
    deliveryOptions: '_deliveryInfo',
};
const _getFulfillmentMethodRequest = {};
const _getFulfillmentMethodResponse = {
    fulfillmentMethod: '_fulfillmentMethod',
};
const _listAvailableFulfillmentMethodsForAddressRequest = {
    address: 'wix.common.Address',
};
const _listAvailableFulfillmentMethodsForAddressResponse = {
    fulfillmentMethods: '_fulfillmentMethod',
};
const _listFulfillmentMethodsRequest = { address: 'wix.common.Address' };
const _listFulfillmentMethodsResponse = {
    fulfillmentMethods: '_fulfillmentMethod',
};
const _pickupInfo = { address: 'wix.common.Address' };
const _queryFulfillmentMethodsRequest = {};
const _queryFulfillmentMethodsResponse = {
    fulfillmentMethods: '_fulfillmentMethod',
};
const _radius = { centerPointAddress: 'wix.common.Address' };
const _updateFulfillmentMethodRequest = {
    fulfillmentMethod: '_fulfillmentMethod',
};
const _updateFulfillmentMethodResponse = {
    fulfillmentMethod: '_fulfillmentMethod',
};
/**
 * Creates a new fulfillment method.
 *
 * Regardless of the value specified in `fulfillment_method.availability.time_zone`, the timezone will be derived from the site properties.
 * @param fulfillmentMethod - Fulfillment method to create.
 * @internal
 * @documentationMaturity preview
 * @requiredField fulfillmentMethod
 * @requiredField fulfillmentMethod.availability.timeZone
 * @requiredField fulfillmentMethod.deliveryOptions.deliveryArea
 * @requiredField fulfillmentMethod.deliveryOptions.deliveryArea.postalCodeOptions.countryCode
 * @requiredField fulfillmentMethod.deliveryOptions.deliveryArea.radiusOptions.centerPointAddress
 * @requiredField fulfillmentMethod.deliveryOptions.deliveryArea.radiusOptions.value
 * @requiredField fulfillmentMethod.pickupOptions.address
 * @adminMethod
 * @returns The created fulfillment method.
 */
export function createFulfillmentMethod(fulfillmentMethod) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { fulfillmentMethod: '$[0]' };
        const responseTransformation = '$.fulfillmentMethod';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createFulfillmentMethodRequest,
            depSchemas: {
                _deliveryArea,
                _deliveryInfo,
                _fulfillmentMethod,
                _pickupInfo,
                _radius,
            },
            fqdnTransformation: {
                paths: [...['fulfillmentMethod']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createFulfillmentMethodResponse,
            depSchemas: {
                _deliveryArea,
                _deliveryInfo,
                _fulfillmentMethod,
                _pickupInfo,
                _radius,
            },
            fqdnTransformation: {
                paths: [...['fulfillmentMethod']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fulfillmentMethod]);
        const reqOpts = ambassadorWixRestaurantsV1FulfillmentMethod.createFulfillmentMethod(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"CreateFulfillmentMethod" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fulfillmentMethod',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a fulfillment method.
 * @param fulfillmentMethodId - The ID of the fulfillment method to retrieve.
 * @internal
 * @documentationMaturity preview
 * @requiredField fulfillmentMethodId
 * @returns The retrieved fulfillment method.
 */
export function getFulfillmentMethod(fulfillmentMethodId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { fulfillmentMethodId: '$[0]' };
        const responseTransformation = '$.fulfillmentMethod';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getFulfillmentMethodRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getFulfillmentMethodResponse,
            depSchemas: {
                _deliveryArea,
                _deliveryInfo,
                _fulfillmentMethod,
                _pickupInfo,
                _radius,
            },
            fqdnTransformation: {
                paths: [...['fulfillmentMethod']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fulfillmentMethodId]);
        const reqOpts = ambassadorWixRestaurantsV1FulfillmentMethod.getFulfillmentMethod(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"GetFulfillmentMethod" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fulfillmentMethodId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a fulfillment method.
 *
 * Each time the fulfillment method is updated, revision increments by 1. The existing revision must be included when updating the fulfillment method. This ensures you're working with the latest fulfillment method information, and it prevents unintended overwrites.
 * @param _id - The ID of the fulfillment method.
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField fulfillmentMethod
 * @requiredField fulfillmentMethod.revision
 * @adminMethod
 * @returns The updated fulfillment method.
 */
export function updateFulfillmentMethod(_id, fulfillmentMethod, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            fulfillmentMethod: { '*': '$[1]', id: '$[0]' },
            fieldMask: '$[2].fieldMask',
        };
        const responseTransformation = '$.fulfillmentMethod';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateFulfillmentMethodRequest,
            depSchemas: {
                _deliveryArea,
                _deliveryInfo,
                _fulfillmentMethod,
                _pickupInfo,
                _radius,
            },
            fqdnTransformation: {
                paths: [...['fulfillmentMethod']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateFulfillmentMethodResponse,
            depSchemas: {
                _deliveryArea,
                _deliveryInfo,
                _fulfillmentMethod,
                _pickupInfo,
                _radius,
            },
            fqdnTransformation: {
                paths: [...['fulfillmentMethod']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, fulfillmentMethod, options]);
        const reqOpts = ambassadorWixRestaurantsV1FulfillmentMethod.updateFulfillmentMethod(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"UpdateFulfillmentMethod" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'fulfillmentMethod',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes a fulfillment method.
 * @param fulfillmentMethodId - The ID of the fulfillment method to delete.
 * @internal
 * @documentationMaturity preview
 * @requiredField fulfillmentMethodId
 * @adminMethod
 */
export function deleteFulfillmentMethod(fulfillmentMethodId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { fulfillmentMethodId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteFulfillmentMethodRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteFulfillmentMethodResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fulfillmentMethodId]);
        const reqOpts = ambassadorWixRestaurantsV1FulfillmentMethod.deleteFulfillmentMethod(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"DeleteFulfillmentMethod" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fulfillmentMethodId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of fulfillment methods by a given query.
 *
 * To learn how to query fulfillment methods, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 *
 * Up to 100 fulfillment methods can be returned per request.
 * @internal
 * @documentationMaturity preview
 */
export function queryFulfillmentMethods(options) {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.fulfillmentMethods',
        pagingMetadata: '$.metadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[1];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryFulfillmentMethodsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryFulfillmentMethodsResponse,
        depSchemas: {
            _deliveryArea,
            _deliveryInfo,
            _fulfillmentMethod,
            _pickupInfo,
            _radius,
        },
        fqdnTransformation: {
            paths: [...['Array#fulfillmentMethods']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixRestaurantsV1FulfillmentMethod.queryFulfillmentMethods(Object.assign(Object.assign({}, payload), (options !== null && options !== void 0 ? options : {})));
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Retrieves a list of fulfillment methods.
 *
 * When an address is not provided in the input, our system retrieves a list encompassing all types of fulfillment methods.
 *
 * Conversely, if an address is given, the response includes non-delivery fulfillment methods along with delivery fulfillment methods that are applicable to the given address, ensuring the address falls within the defined delivery area of these methods.
 *
 * Up to 100 fulfillment methods can be returned.
 *
 * TODO: add support for pagination in the request since it's given in the response, and add docs reference regarding how to do the pagination
 * @internal
 * @documentationMaturity preview
 */
export function listFulfillmentMethods(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { address: '$[0].address' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listFulfillmentMethodsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listFulfillmentMethodsResponse,
            depSchemas: {
                _deliveryArea,
                _deliveryInfo,
                _fulfillmentMethod,
                _pickupInfo,
                _radius,
            },
            fqdnTransformation: {
                paths: [...['Array#fulfillmentMethods']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixRestaurantsV1FulfillmentMethod.listFulfillmentMethods(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"ListFulfillmentMethods" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of fulfillment methods available for a given address.
 *
 * The response includes non-delivery fulfillment methods along with delivery fulfillment methods that are applicable to the given address, ensuring the address falls within the defined delivery area of these methods.
 *
 * Up to 100 fulfillment methods can be returned per request.
 * @internal
 * @documentationMaturity preview
 */
export function listAvailableFulfillmentMethodsForAddress(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            address: '$[0].address',
            cursorPaging: '$[0].cursorPaging',
            fulfillmentMethodIds: '$[0].fulfillmentMethodIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listAvailableFulfillmentMethodsForAddressRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listAvailableFulfillmentMethodsForAddressResponse,
            depSchemas: {
                _deliveryArea,
                _deliveryInfo,
                _fulfillmentMethod,
                _pickupInfo,
                _radius,
            },
            fqdnTransformation: {
                paths: [...['Array#fulfillmentMethods']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixRestaurantsV1FulfillmentMethod.listAvailableFulfillmentMethodsForAddress(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"ListAvailableFulfillmentMethodsForAddress" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=restaurants-v1-fulfillment-method.universal.js.map